export type CheckItemProps = {
  title: string;
  checkItemType: string;
  isFile: boolean;
  subTypes: Array<string>;
  dynamicLimit: number;
  ruleForm: RuleItemProps[];
};

export type TabItemSource = {
  id?: string; // 数据库主键，CRUD使用
  checkItemType: string;
  itemId: string;
  fileTypes: Array<string>;
  errorFields?: any;
  formValues?: any; // 表单数据，通过ant form注入值 { RuleType: rule.checkValue }，例如{FileSize:1}
  checkMethods: any; // 收集校验方法 { RuleType: rule.checkMethod }， {FileSize:"LESS"}
  ruleIds?: any; //  { RuleType: rule.id }， {FileSize:"LESS"} 后端返回的checklist，在接口请求时候，会与表单解析的checklist做匹配，携带上rule层id（表单数据与checklist的解析会遗失id数据，涉及频繁新增）
  isChosenChecks?: string[];
  title?: string;
  isSubItem: boolean; // 是否是子项，为true时，不含children与subItems
  children?: string[]; // 嵌套的子检查项的id
  subItems?: TabItemSource[]; // 嵌套的子检查项
};

export type RuleItemProps = {
  uniqueId: number; //主键
  autoAdded: boolean; // 标记该规则为默认检查项，配置时不勾选也输出质检结果，但是作为提交规范（生成的checkItem.isShowRule为false）
  title: string;
  ruleType: string;
  checkMethods: string[];
  checkValueInput: CheckValueInputProps;
  submitMessage: string;
  checkMessage: string;
};

export enum AccessType {
  READ_ONLY = 'ReadOnly',
  WRITE = 'Write',
}

export type CheckValueInputProps = {
  type: string;
  required: boolean;
  props: any;
  access: AccessType;
};

export enum CheckValueInputType {
  FileSizeInput = 'FileSizeInput',
  Select = 'Select',
  None = 'None',
  NumberInput = 'NumberInput',
  ResolutionInput = 'ResolutionInput',
}
